import { useEffect, useRef } from "preact/hooks";
import { isField } from "@fobu/schema";
import { formatAnswer } from "@fobu/engine";
import { useFormEnv } from "../lib/context";
import { t } from "../lib/i18n";
import { plain } from "../lib/markdown";
import { ResultsNotice, SubmitError } from "./Common";

/** Prüfansicht vor dem Absenden: alle Angaben je Abschnitt, mit „Ändern“. */
export function ReviewView() {
  const { ctl, tpl } = useFormEnv();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
    window.scrollTo?.({ top: 0 });
  }, []);
  const sections = ctl.flow.pages
    .map((p, i) => {
      const page = ctl.idx.pageById.get(p.pageId)!.page;
      const items = p.visibleFieldIds
        .map((id) => ctl.idx.fieldById.get(id)!)
        .filter((f) => isField(f) && f.type !== "consent")
        .map((f) => ({ id: f.id, label: plain(tpl(f.label)), value: formatAnswer(f, ctl.flow.answers[f.id], ctl.other[f.id]) }));
      return { pageId: p.pageId, title: page.title ? plain(tpl(page.title)) : ctl.flow.pages.length > 1 ? t.sectionN(i + 1) : "", items };
    })
    .filter((s) => s.items.length);
  return (
    <section class="fb-page fb-review" aria-labelledby="fb-review-title">
      <h2 id="fb-review-title" class="fb-page-title" tabIndex={-1} ref={heading}>
        {t.reviewTitle}
      </h2>
      <p class="fb-page-desc">{t.reviewIntro}</p>
      {sections.map((s) => (
        <div key={s.pageId} class="fb-review-section">
          <div class="fb-review-head">
            {s.title && <h3 class="fb-review-title">{s.title}</h3>}
            {ctl.def.settings.allowBack && (
              <button type="button" class="fb-linkbtn" onClick={() => ctl.editSection(s.pageId)}>
                {t.reviewEdit(s.title || t.sectionN(1))}
              </button>
            )}
          </div>
          <dl class="fb-summary-list">
            {s.items.map((i) => (
              <div key={i.id}>
                <dt>{i.label}</dt>
                <dd>{i.value || <span class="fb-hint">{t.reviewEmpty}</span>}</dd>
              </div>
            ))}
          </dl>
        </div>
      ))}
      <SubmitError />
      <ResultsNotice />
      <div class="fb-nav">
        <button type="button" class="fb-btn fb-btn--ghost" onClick={() => ctl.editSection(ctl.flow.pages.at(-1)!.pageId)}>
          {t.back}
        </button>
        <button type="button" class="fb-btn fb-btn--primary" disabled={ctl.status === "submitting"} onClick={() => void ctl.submit()}>
          {ctl.status === "submitting" ? t.submitting : t.submit}
        </button>
      </div>
    </section>
  );
}
